'use client';

import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';

type LocalizacaoType = {
  cidadeLocation: string
  estadoLocation: string
  locating: boolean
  /** Pede a localização ao navegador (uma única vez) e resolve a cidade. Só deve ser chamado por ação do usuário. */
  requestLocation: () => void
}

const LocalizacaoEmTempoRealContext = createContext({} as LocalizacaoType);

type Props = {
  children: ReactNode
}

const API_URL = 'https://api.bigdatacloud.net/data/reverse-geocode-client';

export const LocalizacaoProvider = ({ children }: Props) => {
  const [cidadeLocation, setCidade] = useState('');
  const [estadoLocation, setEstado] = useState('');
  const [locating, setLocating] = useState(false);

  const requestLocation = useCallback(() => {
    if (!('geolocation' in navigator)) return;

    setLocating(true);

    navigator.geolocation.getCurrentPosition(
      async ({ coords }) => {
        try {
          const response = await fetch(
            `${API_URL}?latitude=${coords.latitude}&longitude=${coords.longitude}&localityLanguage=pt`,
          );
          const data = await response.json();

          if (data.city) {
            setCidade(data.city);
            setEstado(data.principalSubdivision ?? '');
          }
        } catch (error) {
          console.error('Erro ao obter dados da API', error);
        } finally {
          setLocating(false);
        }
      },
      () => setLocating(false),
      { timeout: 10000, maximumAge: 10 * 60 * 1000 },
    );
  }, []);

  return (
    <LocalizacaoEmTempoRealContext.Provider value={{ cidadeLocation, estadoLocation, locating, requestLocation }}>
      {children}
    </LocalizacaoEmTempoRealContext.Provider>
  );
};

export const Location = () => useContext(LocalizacaoEmTempoRealContext);
